export default __webpack_public_path__ + "static/test_2_2-9b2ae91a0d161d97ec3068e72d14c272.png";